export default __webpack_public_path__ + "static/media/Threshold-Met.ca311938.svg";